import url from './url';

export default {
  isQuickRegister: () => !!url.getFromQueryString('quickRegister'),
};
